import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const TextAreaField = ({
    name,
    id,
    type,
    placeholder,
    value,
    label,
    error,
    info,
    onChange,
    required,
}) => {
  return (
    <div className="form-group">
        <label className='form-label'>{label}</label>
        <textarea type={type} className={classnames('form-control', {'is-invalid' : error})} name={name} id={id} value={value} placeholder={placeholder} onChange={onChange} required={required} aria-label="Default" aria-describedby="inputGroup-sizing-default"></textarea>
        {info && <small className='form-text text-muted'>{info}</small>}
        {error && <div className="invalid-feedback mb-2" style={{textAlign: 'left'}}>{error}</div>}
    </div>
  )
}

TextAreaField.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    type: PropTypes.oneOfType([PropTypes.string]).isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    label: PropTypes.string,
    error: PropTypes.string,
    info: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.string,
}


TextAreaField.defaultProps = {
    type: 'text'
}

export default TextAreaField
